<template>
    <div ref="timeline" class="timeline" @scroll="onTimelineScroll">
		<div class="line" v-if="duration">
			<div v-for="(block, index) in blocks" :style="'width:' + block.width + 'px;'" :key="index" class="block"><span>{{ block.label }}</span></div>
		</div>
	</div>
</template>

<style lang="scss" scoped>

</style>

<script>
    import moment from 'moment'
    export default {
        name: 'WaveformTimeline',
        data(){
            return {
				duration: 0,
				width: 0,
				blocks: [],
				pxPerSecond: 1
            }
        },
        methods: {
            resize(width, pxPerSecond){
				const line = this.$refs.timeline.querySelector('.line')
				if (!line) return
				this.width = width
				this.pxPerSecond = pxPerSecond
				line.style.width = width + 'px'
				this.setBlocks()
            },
            setDuration(duration){
                this.duration = duration
            },
            scrollTo(scrollLeft){
                this.$refs.timeline.scrollLeft = scrollLeft
			},
			setBlocks(){
				const numBlocks = Math.floor(this.duration / 30)
				const blockWidth = this.pxPerSecond * 30
				const blocks = []
				for (let i=0; i < numBlocks; i++){
					const label = moment((i + 1) * 30000).format('mm:ss')
					blocks.push({
						label, 
						width: blockWidth
					})
				}
				this.blocks = blocks
			},
            onTimelineScroll(e){
                const scrollLeftRatio = e.target.scrollLeft / e.target.scrollWidth
                this.$emit('scroll', scrollLeftRatio, e.target.scrollLeft)
			}
        }
    }
</script>